export const normalizeArrayQueryParam = (value) => {
    if (Array.isArray(value)) {
        return value.map((item) => (item == null ? '' : item))
    }

    if (value == null || value === '') return []

    return [value]
}

export const normalizeQueryArrays = (query = {}, arrayKeys = []) => {
    const normalized = { ...query }

    arrayKeys.forEach((key) => {
        normalized[key] = normalizeArrayQueryParam(normalized[key])
    })

    return normalized
}
